 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Appointments~Planner":"Appointments~Planner","Appointments":"Appointments","Planner":"Planner","Attendance~Brvars~Employeerating~Leaves~LunchPlanner~NewCollection~NewLeave~SalesLeadsView~SalesOrde~77f083a0":"Attendance~Brvars~Employeerating~Leaves~LunchPlanner~NewCollection~NewLeave~SalesLeadsView~SalesOrde~77f083a0","Employeerating":"Employeerating","Leaves":"Leaves","appraisalResult":"appraisalResult","user_profile":"user_profile","Attendance~Brvars~JournalEntry~NewCollection~SalesOrdersList~appraisalQuestions~appraisalSummary~app~c23aafbf":"Attendance~Brvars~JournalEntry~NewCollection~SalesOrdersList~appraisalQuestions~appraisalSummary~app~c23aafbf","Attendance":"Attendance","salesquotationslist":"salesquotationslist","appraisalQuestions":"appraisalQuestions","appraisalSummary":"appraisalSummary","appraisee_list":"appraisee_list","user_management":"user_management","Brvars~Collections~CustomerSummary~JournalEntry~LunchPlanner~NewCollection~NewLeave~SalesLeadNew~Sal~f3506268":"Brvars~Collections~CustomerSummary~JournalEntry~LunchPlanner~NewCollection~NewLeave~SalesLeadNew~Sal~f3506268","LunchPlanner":"LunchPlanner","NewLeave":"NewLeave","SalesLeadsView~logisticsDashboard":"SalesLeadsView~logisticsDashboard","SalesLeadsView":"SalesLeadsView","logisticsDashboard":"logisticsDashboard","leave":"leave","Brvars":"Brvars","NewCollection":"NewCollection","SalesOrdersList":"SalesOrdersList","JournalEntry":"JournalEntry","banners":"banners","mealplanner":"mealplanner","mealplannern":"mealplannern","mealplannerw":"mealplannerw","nmealplanner":"nmealplanner","Collections":"Collections","CustomerSummary":"CustomerSummary","SalesLeadNew":"SalesLeadNew","fileUpload":"fileUpload","newLogistics":"newLogistics","summarylist":"summarylist","Chat":"Chat","CustomerDetails":"CustomerDetails","CustomerList":"CustomerList","Home":"Home","SalesLeads":"SalesLeads","SignUp":"SignUp","admin_notification":"admin_notification","appraiserAdd":"appraiserAdd","appsettings":"appsettings","deliveries":"deliveries","despatch":"despatch","deviceregisteration":"deviceregisteration","lunchSchedule":"lunchSchedule","notification":"notification","notification_send":"notification_send"}[chunkId]||chunkId) + "." + {"Appointments~Planner":"07b27c2b","Appointments":"c982a574","Planner":"fdedaa3b","Attendance~Brvars~Employeerating~Leaves~LunchPlanner~NewCollection~NewLeave~SalesLeadsView~SalesOrde~77f083a0":"8910bdb1","Employeerating":"51c3e651","Leaves":"1a59e872","appraisalResult":"43b72690","user_profile":"a0273cea","Attendance~Brvars~JournalEntry~NewCollection~SalesOrdersList~appraisalQuestions~appraisalSummary~app~c23aafbf":"11aa5041","Attendance":"ded16046","salesquotationslist":"35aa31ee","appraisalQuestions":"ec3dd6f5","appraisalSummary":"6b11d42b","appraisee_list":"610469d9","user_management":"bb23c70c","Brvars~Collections~CustomerSummary~JournalEntry~LunchPlanner~NewCollection~NewLeave~SalesLeadNew~Sal~f3506268":"d0898388","LunchPlanner":"dba6df49","NewLeave":"5deaabe3","SalesLeadsView~logisticsDashboard":"dce507b4","SalesLeadsView":"5a7b91b0","logisticsDashboard":"37936586","leave":"2a83fe6c","Brvars":"5ee147e4","NewCollection":"8f7a60fa","SalesOrdersList":"0c394f87","JournalEntry":"366ebf9f","banners":"398ec282","mealplanner":"939d9992","mealplannern":"14a8e76f","mealplannerw":"3d665f52","nmealplanner":"859df730","Collections":"1d540862","CustomerSummary":"5f70f869","SalesLeadNew":"6c545ad3","fileUpload":"8a820923","newLogistics":"038dc654","summarylist":"db8a7836","Chat":"301f7b52","CustomerDetails":"875b2407","CustomerList":"f9396ff4","Home":"ace77206","SalesLeads":"c9646079","SignUp":"c8602747","admin_notification":"7c52b2bf","appraiserAdd":"af2e90f3","appsettings":"d6b7ae65","chunk-4367bb4e":"d7b94b7e","deliveries":"862c62b9","despatch":"a93fab83","deviceregisteration":"dbb9464d","lunchSchedule":"256dcd8c","notification":"3a17ea46","notification_send":"511b1aea"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Appointments~Planner":1,"Employeerating":1,"Leaves":1,"appraisalResult":1,"user_profile":1,"Attendance~Brvars~JournalEntry~NewCollection~SalesOrdersList~appraisalQuestions~appraisalSummary~app~c23aafbf":1,"Attendance":1,"appraisalQuestions":1,"appraisee_list":1,"Brvars~Collections~CustomerSummary~JournalEntry~LunchPlanner~NewCollection~NewLeave~SalesLeadNew~Sal~f3506268":1,"LunchPlanner":1,"NewLeave":1,"SalesLeadsView~logisticsDashboard":1,"SalesLeadsView":1,"logisticsDashboard":1,"leave":1,"Brvars":1,"NewCollection":1,"JournalEntry":1,"banners":1,"mealplanner":1,"mealplannern":1,"mealplannerw":1,"nmealplanner":1,"Collections":1,"SalesLeadNew":1,"fileUpload":1,"newLogistics":1,"Chat":1,"CustomerList":1,"Home":1,"SignUp":1,"admin_notification":1,"deliveries":1,"deviceregisteration":1,"notification_send":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Appointments~Planner":"Appointments~Planner","Appointments":"Appointments","Planner":"Planner","Attendance~Brvars~Employeerating~Leaves~LunchPlanner~NewCollection~NewLeave~SalesLeadsView~SalesOrde~77f083a0":"Attendance~Brvars~Employeerating~Leaves~LunchPlanner~NewCollection~NewLeave~SalesLeadsView~SalesOrde~77f083a0","Employeerating":"Employeerating","Leaves":"Leaves","appraisalResult":"appraisalResult","user_profile":"user_profile","Attendance~Brvars~JournalEntry~NewCollection~SalesOrdersList~appraisalQuestions~appraisalSummary~app~c23aafbf":"Attendance~Brvars~JournalEntry~NewCollection~SalesOrdersList~appraisalQuestions~appraisalSummary~app~c23aafbf","Attendance":"Attendance","salesquotationslist":"salesquotationslist","appraisalQuestions":"appraisalQuestions","appraisalSummary":"appraisalSummary","appraisee_list":"appraisee_list","user_management":"user_management","Brvars~Collections~CustomerSummary~JournalEntry~LunchPlanner~NewCollection~NewLeave~SalesLeadNew~Sal~f3506268":"Brvars~Collections~CustomerSummary~JournalEntry~LunchPlanner~NewCollection~NewLeave~SalesLeadNew~Sal~f3506268","LunchPlanner":"LunchPlanner","NewLeave":"NewLeave","SalesLeadsView~logisticsDashboard":"SalesLeadsView~logisticsDashboard","SalesLeadsView":"SalesLeadsView","logisticsDashboard":"logisticsDashboard","leave":"leave","Brvars":"Brvars","NewCollection":"NewCollection","SalesOrdersList":"SalesOrdersList","JournalEntry":"JournalEntry","banners":"banners","mealplanner":"mealplanner","mealplannern":"mealplannern","mealplannerw":"mealplannerw","nmealplanner":"nmealplanner","Collections":"Collections","CustomerSummary":"CustomerSummary","SalesLeadNew":"SalesLeadNew","fileUpload":"fileUpload","newLogistics":"newLogistics","summarylist":"summarylist","Chat":"Chat","CustomerDetails":"CustomerDetails","CustomerList":"CustomerList","Home":"Home","SalesLeads":"SalesLeads","SignUp":"SignUp","admin_notification":"admin_notification","appraiserAdd":"appraiserAdd","appsettings":"appsettings","deliveries":"deliveries","despatch":"despatch","deviceregisteration":"deviceregisteration","lunchSchedule":"lunchSchedule","notification":"notification","notification_send":"notification_send"}[chunkId]||chunkId) + "." + {"Appointments~Planner":"2bee59f6","Appointments":"31d6cfe0","Planner":"31d6cfe0","Attendance~Brvars~Employeerating~Leaves~LunchPlanner~NewCollection~NewLeave~SalesLeadsView~SalesOrde~77f083a0":"31d6cfe0","Employeerating":"79225b41","Leaves":"df96a54d","appraisalResult":"f1806bd4","user_profile":"85a40f18","Attendance~Brvars~JournalEntry~NewCollection~SalesOrdersList~appraisalQuestions~appraisalSummary~app~c23aafbf":"daca5a6e","Attendance":"79473379","salesquotationslist":"31d6cfe0","appraisalQuestions":"ccd80659","appraisalSummary":"31d6cfe0","appraisee_list":"5ce1722d","user_management":"31d6cfe0","Brvars~Collections~CustomerSummary~JournalEntry~LunchPlanner~NewCollection~NewLeave~SalesLeadNew~Sal~f3506268":"929af710","LunchPlanner":"4376f3db","NewLeave":"65ba3a4f","SalesLeadsView~logisticsDashboard":"97213586","SalesLeadsView":"a4e0477d","logisticsDashboard":"218b565d","leave":"6d53ebe3","Brvars":"b33e7c14","NewCollection":"917fe324","SalesOrdersList":"31d6cfe0","JournalEntry":"c1946aa8","banners":"77d89e6e","mealplanner":"8a3b6213","mealplannern":"c20099d8","mealplannerw":"dbd293b8","nmealplanner":"5bd3523e","Collections":"176540e7","CustomerSummary":"31d6cfe0","SalesLeadNew":"0b4948d3","fileUpload":"76a811a3","newLogistics":"828359a6","summarylist":"31d6cfe0","Chat":"92aeb6f6","CustomerDetails":"31d6cfe0","CustomerList":"90936670","Home":"7bf61de4","SalesLeads":"31d6cfe0","SignUp":"2cf3a68e","admin_notification":"dd7748ec","appraiserAdd":"31d6cfe0","appsettings":"31d6cfe0","chunk-4367bb4e":"31d6cfe0","deliveries":"b3a378bd","despatch":"31d6cfe0","deviceregisteration":"e6bab511","lunchSchedule":"31d6cfe0","notification":"31d6cfe0","notification_send":"99834299"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
